import React, { Component } from 'react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import 'react-table/react-table.css';
import InputNumber from 'antd/lib/input-number';

class EditableTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.instantBookInfo,
    };
    this.renderEditable = this.renderEditable.bind(this);
    this.renderNotEditable = this.renderNotEditable.bind(this);
    this.handleCellChange = debounce(this.handleCellChange.bind(this), 300);
  }

  handleCellChange(value, cellInfo) {
    if (!value) return;
    const data = [...this.state.data];
    data[cellInfo.index][cellInfo.column.id] = value;
    this.persist(value, cellInfo);
    this.setState({ data });
  }

  persist(value, cellInfo) {
    const { changeCellChange } = this.props;
    const instantBookParams = {
      id: cellInfo.original.id,
      [cellInfo.column.id]: value,
    };
    changeCellChange(instantBookParams);
  }

  renderNotEditable(cellInfo) {
    const { editable } = cellInfo.original;

    return (
      <div
        style={{ backgroundColor: '#fafafa' }}
        className={editable ? 'editable-cell' : 'not-editable-cell'}
      >
        {this.state.data[cellInfo.index][cellInfo.column.id]}
      </div>
    );
  }

  renderEditable(cellInfo) {
    const { editable } = cellInfo.original;

    return editable ? (
      <InputNumber
        className="number-input"
        formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        parser={value => value.replace(/\$\s?|(,*)/g, '')}
        defaultValue={this.state.data[cellInfo.index][cellInfo.column.id]}
        onChange={value => this.handleCellChange(value, cellInfo)}
      />
    ) : (
      <div />
    );
  }
  render() {
    const { data } = this.state;
    return (
      <ReactTable
        data={data}
        columns={[
          {
            Header: 'Product',
            accessor: 'product',
            Cell: this.renderNotEditable,
          },
          {
            Header: 'Editing',
            accessor: 'editing',
            Cell: this.renderEditable,
          },
          {
            Header: 'Animation',
            accessor: 'animation',
            Cell: this.renderEditable,
          },
          {
            Header: 'Production',
            accessor: 'production',
            Cell: this.renderEditable,
          },
        ]}
        showPagination={false}
        defaultPageSize={data.length}
        className="-striped -highlight"
      />
    );
  }
}

EditableTable.propTypes = {
  instantBookInfo: PropTypes.array,
  changeCellChange: PropTypes.func,
};

export default EditableTable;



// WEBPACK FOOTER //
// ./src/components/DashboardFreelancerMain/InstantBook/InstantBookPricingPopup/EditableTable.js